"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PriceAndTag = exports.RadioAndName = exports.PlanSelector = void 0;
const react_1 = __importStar(require("react"));
const html_react_parser_1 = __importDefault(require("html-react-parser"));
const page_wrapper_1 = require("../page-wrapper");
const styles_1 = require("./styles");
const PlanSelector = ({ availablePlanOptions, selectedPlanIndex, bestValuePlanIndex, activePlanIndex, bestValueTagText, activePlanTagText, onSelect, planSelectorTitle }) => {
    const deviceType = (0, react_1.useContext)(page_wrapper_1.PageContext).deviceType;
    return (react_1.default.createElement(styles_1.ComponentContainer, { deviceType: deviceType },
        planSelectorTitle && react_1.default.createElement(styles_1.TitleContainer, null, planSelectorTitle),
        react_1.default.createElement(styles_1.PlanSelectorContainer, { deviceType: deviceType }, availablePlanOptions.map((plan, index) => (react_1.default.createElement(styles_1.PlanItem, { key: plan.termAsin, deviceType: deviceType },
            react_1.default.createElement(exports.RadioAndName, Object.assign({}, plan, { deviceType: deviceType, isSelected: index === selectedPlanIndex, onChange: () => onSelect(index) })),
            react_1.default.createElement(exports.PriceAndTag, Object.assign({}, plan, { bestValueTagText: bestValueTagText, activePlanTagText: activePlanTagText, isSelected: index === selectedPlanIndex, isBestValue: index === bestValuePlanIndex, deviceType: deviceType, isActivePlan: activePlanIndex !== undefined && index === activePlanIndex }))))))));
};
exports.PlanSelector = PlanSelector;
const RadioAndName = (props) => {
    return (react_1.default.createElement("div", { style: {
            gridArea: 'radioAndName',
            display: 'grid',
            gridTemplateAreas: `'radio planName'`,
            gridAutoColumns: 'min-content auto',
            columnGap: '13px',
            alignItems: 'center'
        } },
        react_1.default.createElement(styles_1.Radio, { id: props.termAsin, type: 'radio', name: 'PlanSelector', checked: props.isSelected, onChange: props.onChange }),
        react_1.default.createElement(styles_1.CustomRadio, { visible: true }),
        react_1.default.createElement(styles_1.PlanName, { deviceType: props.deviceType }, (0, html_react_parser_1.default)(props.planName))));
};
exports.RadioAndName = RadioAndName;
const PriceAndTag = (props) => {
    return (react_1.default.createElement("div", { style: {
            gridArea: 'priceAndTag',
            display: 'grid',
            gridTemplateAreas: `
        'price'
        'tag'`
        } },
        react_1.default.createElement(styles_1.Price, Object.assign({}, props), (0, html_react_parser_1.default)(props.priceText)),
        props.activePlanTagText && (react_1.default.createElement(styles_1.CurrentPlanTag, { visible: props.isActivePlan, deviceType: props.deviceType }, (0, html_react_parser_1.default)(props.activePlanTagText))),
        react_1.default.createElement(styles_1.BestValueTag, { visible: props.isBestValue, deviceType: props.deviceType }, props.bestValueTagText && (0, html_react_parser_1.default)(props.bestValueTagText))));
};
exports.PriceAndTag = PriceAndTag;
